import { Button, Card, Space, Typography } from "antd"
import { PropsWithChildren, ReactNode } from "react"

type Props = PropsWithChildren & {
  title: string
  description: string
  onUpdate: () => void
  isUpdating: boolean
  updateDisabled: boolean
  additionalActions?: ReactNode
  id?: string
}

const SettingsCard = ({ title, description, children, onUpdate, isUpdating, updateDisabled, additionalActions, id }: Props) => {
  const updateButton = <Button type="primary" onClick={onUpdate} loading={isUpdating} disabled={isUpdating || updateDisabled}>Update</Button>

  return <Card
    id={id}
    title={<div style={{ margin: "16px 0" }}>
      {title}
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>{description}</Typography.Text>
    </div>}
    extra={additionalActions ? <Space size="small">{additionalActions} {updateButton}</Space> : updateButton}
  >
    {children}
  </Card>
}

export default SettingsCard